import { ProductMembersListPageGroupFilterState } from "@/product/member/page/filters/ProductMembersListPageGroupFilter"
import { ProductMembersListPageRoleFilterState } from "@/product/member/page/filters/ProductMembersListPageRoleFilter"
import { MembersProfileFieldFilterState } from "@components/dropdown/profile-field/MembersProfileFieldFilter"
import { DiscoTableToolbarStateWithSort } from "@disco-ui/table/header/search/DiscoTableSortDropdown"
import { useState } from "react"

export type ProductMembersListToolbarState = DiscoTableToolbarStateWithSort &
  Partial<ProductMembersListPageRoleFilterState> &
  ProductMembersListPageGroupFilterState &
  MembersProfileFieldFilterState

const TOOLBAR_STATE_BY_TYPE = {
  course: {
    selectedRole: null,
    sort: {
      id: "none",
      order: { field: "role" },
      title: "Sort",
    },
  },
  pathway: {
    sort: {
      id: "none",
      order: { field: "member_name" },
      title: "Sort",
    },
  },
}

export default function useProductMembersListToolbarState(
  productType: "course" | "pathway"
): {
  toolbarState: ProductMembersListToolbarState
  setToolbarState: React.Dispatch<React.SetStateAction<ProductMembersListToolbarState>>
} {
  const [toolbarState, setToolbarState] = useState<ProductMembersListToolbarState>({
    search: "",
    selectedGroup: { value: "all", title: "All Groups" },
    profileFields: {},
    direction: "ASC",
    ...TOOLBAR_STATE_BY_TYPE[productType],
  })

  return { toolbarState, setToolbarState }
}
